export default __webpack_public_path__ + "static/media/down5.ba44dc48.jpg";